<template>
  <div class="dashboard">
    <TopBar />
    <Content />
  </div>
</template>

<script>
import TopBar from '@/components/dashboard/TopBar.vue'
import Content from '@/components/dashboard/Content.vue'
export default {
  name: 'DashboardLayout',
  components: { 
    TopBar, 
    Content,
  },
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .dashboard {
    background-color: $black;
  }
}
.dashboard {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr;
  grid-template-areas: 
    'topBar'
    'content'
  ;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: $white;
  padding: 0.5rem;
  gap: 0.5rem;
}
</style>